import { render, staticRenderFns } from "./shareholder.vue?vue&type=template&id=ae14e4ec&scoped=true&"
import script from "./shareholder.vue?vue&type=script&lang=js&"
export * from "./shareholder.vue?vue&type=script&lang=js&"
import style0 from "./shareholder.vue?vue&type=style&index=0&id=ae14e4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae14e4ec",
  null
  
)

export default component.exports